export default __webpack_public_path__ + "static/media/530.362ba731.gif";